import { Form } from 'factorial-form'

class ImportEmployeesToSMForm extends Form {
  constructor(values: object = {}) {
    super(values, {
      effective_at: 'string',
      employee_id: 'number',
      number_of_rest_days_in_cents: 'number',
    })
  }
}

export default ImportEmployeesToSMForm
